export default "__VITE_ASSET__CK1r6j39__"